import DeliveryPointPage from 'Pages/static/DeliveryPointPage';
import { SALESFORCE_CONTACT_URL, SALESFORCE_FAQ_URL } from 'PotagerLogic/Constants/Salesforce';

export default [
  {
    name: 'devenir-point-de-retrait',
    path: '/devenir-point-de-retrait-partenaire/',
    meta: {
      scrollToTop: true,
    },
    component: DeliveryPointPage,
  },

  {
    name: 'contact',
    path: '/contact',
    beforeEnter() {
      window.location = SALESFORCE_CONTACT_URL;
    }
  },

  {
    name: 'faq',
    path: '/faq',
    beforeEnter() {
      window.location = SALESFORCE_FAQ_URL;
    }
  }
];
